import { accessibility } from './modules/accessibility.js'
import { SG1Logs } from './modules/logs.js'
import { isForcedProd, isObject } from './modules/utilities.js'
import { componentRender } from './componentRender.js'

// MAIN ================================
export const main = (config, profile, context) => {
   try {
      renderPlaceholders(config)

      // Stock le profile (dans les cas ou on charge que des composants sans métadatas) passé au loader,
      // qui sera écrasé par le profile passé dans metadata pour pages accueils
      window.dataStoreHP = {}
      window.dataStoreHP.pageId = profile

      // SG1updateComponent pour les ABTest
      window.SG1updateComponent = (eventId = '', data = {}) => {
         if (isObject(data) && eventId !== '' && config.events && config.events[eventId] !== undefined && config.events[eventId].state !== undefined) {
            if (window.dataStoreHP.SSEstatus === 'disconnected') {
               // si on execute la fonction a la fin de la connexion SSE
               config.events[eventId].state.value = data
            } else {
               // si on execute la fonction avant la connexion SSE on attend l'évent de fin de transmission
               document.addEventListener('sseEndOfTransmition', () => {
                  config.events[eventId].state.value = data
               })
            }
         } else {
            console.error('SG1updateComponent: eventId ou data non défini')
         }
      }

      SG1Logs.init()

      let SSE = SSEConnection(config.sseURL, context, profile)

      let SSEResponseTime = new Date().getTime()

      if (SSE !== null) {
         SSE.addEventListener('renderEvent', (event) => {
            try {
               let data = event.data
               if (process.env.NODE_ENV === 'production') {
                  // condition webpack de COMPILATION pas de run coté client
                  data = JSON.parse(data)
               } else {
                  if (isForcedProd()) {
                     data = JSON.parse(data)
                  }
               }

               componentRender(data, config.events)

            } catch (error) {
               console.error('Catch error: SSE renderEvent', { error: error, event: event })
               SG1Logs.logError(`main > SSE renderEvent : ${error.message}`)
            }
         })

         SSE.addEventListener('location', (event) => {
            if (event.data.URL !== '') window.location.href = event.data
         })

         // SSE Error
         SSE.addEventListener('error', (event) => {
            console.error('SSE connexion error : ', JSON.parse(event.data).message)
         })

         // SSE EndOfTransmission
         SSE.addEventListener('EOT', (event) => {
            let eotEvent = new CustomEvent(`sseEndOfTransmition`, {
               detail: {
                  eot: true,
                  responseTime: new Date().getTime() - SSEResponseTime,
               },
            })
            document.dispatchEvent(eotEvent)

            removePlaceholders()

            setTimeout(() => {
               window.prerenderReady = true // pour prerender.io
            }, 10000)

            SSE.close()

            accessibility()

            window.dataStoreHP.SSEstatus = 'disconnected'
         })
      } else {
         throw ('SSE URL non défini')
      }

   } catch (error) {
      console.error('SG1.js', error)
      SG1Logs.logError(`main : ${error.message}`)
      SG1Logs.incLog('Err_PORCH')
   }
}

const SSEConnection = (sseURL, context, profile) => {
   let mockPath = 'mock-sse.json'
   let SSE = null
   // Mocks SSE
   if (process.env.NODE_ENV === 'development') {
      if (!isForcedProd()) {
         const { MockEvent, EventSource: EventSourceMock } = require('mocksse')
         EventSource = EventSourceMock
         let mockFile = require('../mocks/' + mockPath)
         new MockEvent(mockFile)
      }
   }

   // Connexion SSE

   // Ajout des éventuels paramètres de query string
   let queryString = window.location.search
   if (queryString !== '' && context !== null) {
      queryString += '&context=' + context;
   } else if (queryString === '' && context !== null) {
      queryString += '?context=' + context;
   }

   if (sseURL.path[profile] === undefined) return null

   let URL = sseURL.domain.default + '/' + sseURL.path[profile] + queryString

   if (process.env.NODE_ENV === 'development') {
      if (!isForcedProd()) {
         URL = '/'
      } else {
         URL = sseURL.domain.development + '/' + sseURL.path[profile] + queryString
      }
   } else {
      if (sseURL.domain.exceptions && sseURL.domain.exceptions.length > 0) {
         sseURL.domain.exceptions.forEach((exception) => {
            exception.rules.forEach((rule) => {
               if (window.location.hostname.indexOf(rule) !== -1) {
                  URL = exception.domain + '/' + sseURL.path[profile] + queryString
               }
            })
         })
      }
   }

   SSE = new EventSource(URL, { withCredentials: true })
   window.dataStoreHP.SSEstatus = 'connected'

   return SSE
}

const removePlaceholders = () => {
   const placeholders = document.querySelectorAll('.placeholder')
   placeholders.forEach(placeholder => {
      placeholder.classList.remove('placeholder')
   })
   const placeholderStyle = document.getElementById('placeholderStyle')
   if (placeholderStyle) {
      placeholderStyle.remove()
   }
}

const renderPlaceholders = (config) => {
   try {
      let placeholderStyle = ''
      // sortir tous les clé de config.events qui contiennent placeholder: true
      const placeholders = Object.keys(config.events).filter(key => config.events[key].placeholder)
      if (placeholders.length === 0) return
      // pour chaque clé, poser la classe placeholder sur l'élément du DOM contenu dans config.events[key].elementId
      placeholders.forEach(key => {
         const element = document.getElementById(config.events[key].elementId)
         if (element !== null) {
            element.classList.add('placeholder')
            placeholderStyle += config.events[key].placeholderStyle
         }
      })
      const placeholderNode = document.createElement('style')
      placeholderNode.id = 'placeholderStyle'
      placeholderNode.textContent = placeholderStyle
      document.head.appendChild(placeholderNode)
   } catch (error) {
      console.error('Catch error: renderPlaceholders', { error: error })
      SG1Logs.logError(`renderPlaceholders : ${error.message}`)
   }
}
